import React from "react";
import { motion } from "framer-motion";
import { CTAButton, TrustBadges } from "./ui";
import { heroMicrocopy, heroMockup } from "./data";
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#f4f9ff]" data-id="element-95" data-mp="9ktefowaq4ya">
      <div className="pointer-events-none absolute -left-32 top-0 h-72 w-72 rounded-full bg-[#dbeaff] opacity-70 blur-3xl" data-id="element-96" data-mp="9l37jlcn0s87" />
      <div className="pointer-events-none absolute -right-28 bottom-0 h-72 w-72 rounded-full bg-[#e0f2e7] opacity-70 blur-3xl" data-id="element-97" data-mp="129h19owp12dy" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-4 pb-10 pt-8 sm:px-8 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-98" data-mp="xa4ibf8y0fgn">
        <div className="text-center lg:text-left" data-id="element-99" data-mp="sd4cn5g09eq2">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[var(--accent)]" data-id="element-100" data-mp="nb6mrsd3nlo5">
            Pequeños Pasos, Grandes Logros™
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-3 font-serif-display text-[1.95rem] font-semibold leading-[1.08] tracking-[-0.03em] text-[var(--ink)] sm:text-[2.9rem] lg:text-[3.1rem]" data-id="element-101" data-mp="3j9agpbwlmo4m">
            Tal vez no necesite que se lo repitas una vez más.{" "}
            <span className="text-[var(--accent)]" data-id="element-102" data-mp="358hlsq2dxr0z">
              Tal vez necesite otra forma de ser acompañado.
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-lg lg:mx-0" data-id="element-103" data-mp="2qlepgmpstof8">
            Dejá de intentar las mismas estrategias que no funcionan. Una colección práctica de
            6 guías diseñada para mamás y papás que necesitan herramientas reales en rutinas,
            atención y regulación emocional ante el TDAH y el Autismo.
          </motion.p>

          {/* Mockup appears between copy and CTA on mobile only, sized so the CTA stays visible. */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative mx-auto mt-6 w-full max-w-[210px] lg:hidden" data-id="element-104" data-mp="ddwyf4iylwfm">
            <div className="absolute inset-x-6 bottom-2 h-10 rounded-full bg-[#296fe8]/20 blur-2xl" data-id="element-105" data-mp="1126mkd3naw9x" />
            <img src={heroMockup} alt="Colección Pequeños Pasos, Grandes Logros: 6 guías de estrategias prácticas" className="relative w-full rounded-2xl border-4 border-white object-contain shadow-[0_22px_50px_-24px_rgba(23,50,77,0.55)]" loading="eager" data-id="element-106" data-mp="x1w80c1sexjg" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.26
        }} className="mt-6 sm:mt-8" data-id="element-107" data-mp="1x783jjm4pjs0">
            <CTAButton data-id="element-108" data-mp="2686946c7tzcp">Quiero nuevas estrategias</CTAButton>
            <p className="mt-3 text-xs font-semibold leading-relaxed text-[var(--muted)] sm:text-[13px]" data-id="element-109" data-mp="2b1hjghg8ky9d">
              {heroMicrocopy}
            </p>
            <TrustBadges className="mt-3 lg:justify-start" data-id="element-110" data-mp="2kyna5okxun92" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 14
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative hidden lg:block" data-id="element-111" data-mp="2p0h5dhcd6z1u">
          <div className="absolute inset-x-16 bottom-6 h-16 rounded-full bg-[#296fe8]/20 blur-3xl" data-id="element-112" data-mp="uoal7t1ht7xe" />
          <img src={heroMockup} alt="Colección Pequeños Pasos, Grandes Logros: 6 guías de estrategias prácticas" className="relative mx-auto w-full max-w-[440px] rounded-[1.75rem] border-[6px] border-white object-contain shadow-[0_36px_70px_-30px_rgba(23,50,77,0.6)]" loading="eager" data-id="element-113" data-mp="zlsvbmr8xt6z" />
        </motion.div>
      </div>
    </header>;
}